module.exports = __webpack_public_path__ + "static/MapLargeBackground-00fe2eaa33971e6b6fdb79a943f89c44.svg";